module.exports = __webpack_public_path__ + "static/media/claims_live_people.fd44dbd0.svg";